import { MailSettingsApi } from './http-common';

const authorizationHeaders = () => {
  const token = localStorage.getItem('vue-token');

  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getMailSettings = () => MailSettingsApi
  .get('', { headers: authorizationHeaders() })
  .then(response => response.data);

export const saveMailSettings = settings => MailSettingsApi
  .put('', settings, { headers: authorizationHeaders() })
  .then(response => response.data);

export const sendTestMail = (to, settings) => MailSettingsApi
  .post('test', { to, settings }, { headers: authorizationHeaders() })
  .then(response => response.data);
